// Catalog. We sell in EUR (Europe). Subscription-first business model.
// Authoritative prices live on the backend (server.py CATALOG). These mirror them for display.

export const CATALOG_ITEMS = {
  "bundle-starter": {
    id: "bundle-starter",
    name: "Starter",
    supply: "1 Week Supply",
    sachets: "7 Sachets",
    price: 19.0,
    subscribable: false,
    frequency: null,
    image: "/images/brand/sachet_cut.png",
  },
  "daily-wellness": {
    id: "daily-wellness",
    name: "Daily Wellness",
    supply: "1 Month Supply",
    sachets: "30 Sachets",
    price: 59.0,
    subscribePrice: 50.15,
    subscribable: true,
    frequency: "Every 30 days",
    image: "/images/brand/bundle_monthly.png",
  },
  "bundle-quarterly": {
    id: "bundle-quarterly",
    name: "Complete Support",
    supply: "3 Month Supply",
    sachets: "90 Sachets",
    price: 159.0,
    subscribePrice: 135.15,
    subscribable: true,
    frequency: "Every 90 days",
    image: "/images/brand/bundle_quarterly.png",
  },
};

export const getItem = (id) => CATALOG_ITEMS[id];

export const getUnitPrice = (id, mode) => {
  const it = CATALOG_ITEMS[id];
  if (!it) return 0;
  return mode === "subscribe" && it.subscribable ? it.subscribePrice : it.price;
};

// Product page hero product (the monthly Daily Wellness).
export const PRODUCT = {
  id: "daily-wellness",
  name: "Premium Daily Wellness Supplement",
  overline: "Daily Wellness",
  price: 59.0,
  subscribePrice: 50.15,
  perServing: 1.97,
  description: "Daily support for gut health, energy, focus, vitality and immune resilience.",
  image: "/images/brand/sachet.png",
  hero: "/images/brand/sachet.png",
};

// Subscription-first shop plans (order matters: subscriptions first, starter is secondary).
export const PLANS = [
  { id: "daily-wellness", popular: true, frequency: "every 30 days", perServingOnce: 1.97, perServingSub: 1.67 },
  { id: "bundle-quarterly", bestValue: true, frequency: "every 90 days", perServingOnce: 1.77, perServingSub: 1.5 },
  { id: "bundle-starter", oneTimeOnly: true, perServingOnce: 2.71 },
];

export const formatPrice = (n) =>
  `€${Number(n).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
